<template>
<!-- Apps Modal -->
<!-- Opens from the modal toggle button in the header -->
<div class="modal fade" id="one-modal-apps" tabindex="-1" role="dialog" aria-labelledby="one-modal-apps" aria-hidden="true">
  <div class="modal-dialog modal-dialog-top modal-sm" role="document">
    <div class="modal-content">
      <div class="block block-themed block-transparent mb-0">
        <div class="block-header bg-primary-dark">
          <h3 class="block-title">Apps</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
                <i class="si si-close"></i>
              </button>
            </div>
        </div>
        <div class="block-content block-content-full">
          <div class="row gutters-tiny">
            <div class="col-6">
              <!-- CRM -->
              <a class="block block-rounded block-themed bg-info" data-toggle="modal" data-target="#add_plant">
                <div class="block-content text-center">
                  <i class="si si-plus fa-2x text-white-75"></i>
                    <p class="font-w600 font-size-sm text-white mt-2 mb-3">
                      Plant
                    </p>
                </div>
              </a>
              <!-- END CRM -->
            </div>
              <div class="col-6">
                <!-- Products -->
                <a class="block block-rounded block-themed bg-primary" data-toggle="modal" data-target="#add_strain">
                  <div class="block-content text-center">
                    <i class="si si-plus fa-2x text-white-75"></i>
                      <p class="font-w600 font-size-sm text-white mt-2 mb-3">
                        Strain
                      </p>
                  </div>
                </a>
                <!-- END Products -->
              </div>
              <div class="col-6">
                <!-- Sales -->
                <a class="block block-rounded block-themed bg-danger mb-0" data-toggle="modal" data-target="#create_package">
                  <div class="block-content text-center">
                    <i class="si si-plus fa-2x text-white-75"></i>
                      <p class="font-w600 font-size-sm text-white mt-2 mb-3">
                        Package
                      </p>
                  </div>
                </a>
                <!-- END Sales -->
              </div>
              <div class="col-6">
                <!-- Payments -->
                <a class="block block-rounded block-themed bg-warning mb-0" data-toggle="modal" data-target="#add_reminder">
                  <div class="block-content text-center">
                    <i class="si si-plus fa-2x text-white-75"></i>
                      <p class="font-w600 font-size-sm text-white mt-2 mb-3">
                        Reminder
                      </p>
                  </div>
                </a>
                <!-- END Payments -->
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>
<!-- END Apps Modal -->
</template>

<script>
export default {
  name: 'HeaderPopup',
};
</script>



// WEBPACK FOOTER //
// source/modals/HeaderPopup.vue